import { Basketball3x3IncidentId } from '@collector/sportsapi-client-legacy'
import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

export const ThrowInPopup = new PopupBuilder('Throw In', {
  incident_id: Basketball3x3IncidentId.ThrowIn,
})
  .withTeamSelection()
  .omitDetailsView()
  .build()
